import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from "react-chartjs-2"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { convertBytesUnit, printFormattedBytes } from "helpers/common";

ChartJS.register(ArcElement, Tooltip, Legend);

const StorageChart = ({ storageDetails }) => {
  const storageUtilized = convertBytesUnit(storageDetails?.storage_used || 0, "mb", "bytes");
  const storageRemaining = convertBytesUnit(storageDetails?.storage_remaining || 0, "mb", "bytes");

  const total = storageUtilized + storageRemaining;

  // Minimum display percentage to visually show tiny slices
  const MIN_DISPLAY_PERCENTAGE = 0.01;
  let displayUtilized = storageUtilized;
  let displayRemaining = storageRemaining;

  const utilizedPercentage = storageUtilized / total;
  const remainingPercentage = storageRemaining / total;

  // Apply minimum if too small
  if (storageUtilized && utilizedPercentage < MIN_DISPLAY_PERCENTAGE) {
    const adjustedUtilized = total * MIN_DISPLAY_PERCENTAGE;
    const adjustedRemaining = total - adjustedUtilized;
    displayUtilized = adjustedUtilized;
    displayRemaining = adjustedRemaining;
  }

  const data = {
    labels: ['Utilized Storage Space', 'Storage Remaining'],
    datasets: [
      {
        label: 'Storage Usage',
        data: [displayUtilized, displayRemaining],
        backgroundColor: [
          '#ff9882',
          '#b0d6e8'
        ],
        borderColor: '#ffffff',
        borderWidth: 5,
        borderRadius: 10,
      },
    ],
  };

  const options = {
    cutout: '50%',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const index = tooltipItem.dataIndex;
            const value = index === 0 ? storageUtilized : storageRemaining;
            return value ? printFormattedBytes(value) : "0.00 MB";
          }
        }
      },
      datalabels: {
        color: '#222',
        font: {
          weight: 'bold',
          size: 12
        },
        textShadowBlur: 4,
        textShadowColor: 'rgba(0, 0, 0, 0.5)',
        formatter: (value, context) => {
          const index = context.dataIndex;
          const actualValue = index === 0 ? storageUtilized : storageRemaining;
          return actualValue ? printFormattedBytes(actualValue) : "0.00 MB";
        },
        textStrokeColor: "rgba(255, 255, 255, 0.8)",
        textStrokeWidth: 1,
      }
    }
  };

  return (
    <div className="pb-3">
      <Doughnut
        data={data}
        options={options}
        plugins={[ChartDataLabels]}
        height={300}
      />
    </div>
  );
};

export default StorageChart;
